import type {
  ApiEventId,
  ApiInternshipId,
  ApiJobId,
  ApiListingApplicationId,
  ApiOrgId,
  ApiVolopId,
} from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';
import { keyBy } from '#/utils/functional/array/keyBy';

type ApiListingId =
  | ApiJobId
  | ApiInternshipId
  | ApiVolopId
  | ApiEventId
  | ApiOrgId;

type ApiResponse = {
  listings: {
    id: ApiListingId;
    applicationId: ApiListingApplicationId | null;
    saved: boolean;
  }[];
};

function mapResponse(
  response: ApiResponse,
): Partial<Record<ApiListingId, ApiResponse['listings'][number]>> {
  return keyBy(response.listings ?? [], 'id');
}

const endpoint = new FetchEndpoint({
  urlFactory: (listingIds) => {
    if (listingIds.length === 0) return;
    return '/data/userdashboard/listing-extras';
  },
  optionsFactory: (listingIds: ApiListingId[]) => ({
    method: 'post',
    body: { listingIds },
  }),
  mapResponse,
});

// Exports

export const userDashboardApiClientFetchListingExtras = endpoint.client();

export const useUserDashboardApiFetchListingExtras = endpoint.hook();

export const userDashboardApiServerFetchListingExtras = endpoint.server();
